import { render, staticRenderFns } from "./BasicDrawer.vue?vue&type=template&id=f9b49c86&scoped=true"
import script from "./BasicDrawer.vue?vue&type=script&lang=js"
export * from "./BasicDrawer.vue?vue&type=script&lang=js"
import style0 from "./BasicDrawer.vue?vue&type=style&index=0&id=f9b49c86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b49c86",
  null
  
)

export default component.exports